import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import useOpenState from '../../../../hooks/useOpenState';
import MiniFormDialog from '../../../../components/modal/miniFormDialog';
import HistoryIcon from '@mui/icons-material/History';
import API from '../../../../app/api';
import {useDispatch} from 'react-redux';
import {setSnackbar} from '../../../../store/reducers/globals';
import {AgyleTable, createAgyleTableColumn} from '../../../../components/table/AgyleTable';
import Exporter from '../../../../util/exporter';

const columnsTable = [
    createAgyleTableColumn('no', 'No.', 1, null, 'count', 'notSort', 'medium', 'center', true, false, null, null, null),
    createAgyleTableColumn('patientId', 'Patient', 2, 'patientId', 'string', '', 'medium', 'left', true, true, null, null, null),
    createAgyleTableColumn('visitNumber', 'Visit number', 3, 'visitNumber', 'string', '', 'medium', 'left', true, true, null, null, null),
    createAgyleTableColumn('startDate', 'Start date', 4, 'startDate', 'date', '', 'medium', 'left', true, true, null, null, null),
    createAgyleTableColumn('endDate', 'End date', 5, 'endDate', 'date', '', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('location', 'Location', 6, 'location', 'string', '', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('locationDescription', 'Location description', 7, 'locationDescription', 'string', '', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('wardLocation', 'Ward location', 8, 'wardLocation', 'string', '', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('locationId', 'locationId', 9, 'locationId', 'string', '', 'medium', 'left', true, false, null, null, null),
];

const PatientLocationHistory = ({patient, disabled}) => {
    const {t} = useTranslation();
    const controller = new AbortController();
    const dispatch = useDispatch();

    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(false);

    const [isLocationModalOpen, openLocationModal, closeLocationModal] = useOpenState(false, true);

    useEffect(() => {
        return () => {
            controller.abort();
        };
    }, []);

    const handlePatientLocation = () => {
        if (patient?.admission) {
            const {startDate, endDate, __id} = patient.admission;
            setLoading(true);
            const obj = {
                from: startDate,
                to: endDate ? endDate : new Date().toISOString(),
                attendanceId: __id,
            };
            API.getPatientLocation(obj, controller.signal)
                .then(res => {
                    setHistory(res);
                    openLocationModal();
                })
                .catch(error => {
                    console.error(error);
                    dispatch(setSnackbar({type: 'error', message: 'Error fetching patient location history'}));
                })
                .finally(() => setLoading(false));
        } else {
            dispatch(setSnackbar({type: 'error', message: 'Patient is not admitted'}));
        }
    };

    const handleCloseModal = () => {
        closeLocationModal();
        setHistory([]);
        setLoading(false);
    };

    const handleExportCSV = () => {
        if (history.length > 0) {
            const ptId = patient?.patient?.__id;
            Exporter.handleExport(history, `${ptId ? ptId + '_' : ''}location.csv`);
        } else {
            dispatch(setSnackbar({type: 'error', message: 'No data to export'}));
        }
    };

    return (
        <>
            <AgyleButton
                disabled={disabled || loading}
                onClick={handlePatientLocation}
                color="primary"
                loading={loading}
                startIcon={<HistoryIcon/>}
            >
                {t('Location History')}
            </AgyleButton>


            <MiniFormDialog
                title={t('Patient Location History')}
                open={isLocationModalOpen}
                onClose={handleCloseModal}
                onSave={handleExportCSV}
                width="lg"
                submitText={t('Export to CSV')}
            >
                <>
                    <AgyleTable
                        columns={columnsTable}
                        data={history}
                        disableFilter
                    />
                </>
            </MiniFormDialog>
        </>
    );
};

export default PatientLocationHistory;